import { render, staticRenderFns } from "./ReviewInsuredMenu.vue?vue&type=template&id=4823b930&"
import script from "./ReviewInsuredMenu.vue?vue&type=script&lang=js&"
export * from "./ReviewInsuredMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReviewInsuredMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports